import { render, staticRenderFns } from "./Imagefilm.vue?vue&type=template&id=21787c8f&scoped=true"
import script from "./Imagefilm.vue?vue&type=script&lang=js"
export * from "./Imagefilm.vue?vue&type=script&lang=js"
import style0 from "./Imagefilm.vue?vue&type=style&index=0&id=21787c8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21787c8f",
  null
  
)

export default component.exports